import { createSelector } from '@ngrx/store';
import { selectCaseState } from './common-case.selector';

export const selectAddressInformations = createSelector(
  selectCaseState,
  (state) => state.case.addressInformations
);
